import { defineComponent, PropType } from 'vue';
import { FairplayerFallbackImageUi } from '@/common/primary/fairplayer-image/FairplayerFallbackImage.ui';
import { FairplayerImageVue } from '@/common/primary/fairplayer-image';
import { ImageResolution } from '@/common/primary/ImageResolution';

export default defineComponent({
  name: 'FanImage',

  props: {
    highlightable: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    lazy: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    url: {
      type: String as PropType<string>,
      default: '',
      required: false,
    },
    resolution: {
      type: String as PropType<ImageResolution>,
      default: ImageResolution.SM,
      required: false,
    },
  },

  components: { FairplayerImageVue },

  emits: ['load'],

  setup(props, { emit }) {
    const onLoad = () => emit('load');

    return {
      onLoad,
      FairplayerFallbackImageUi,
    };
  },
});
